import { resolveEffectiveSubtype } from '../infer';
import { isPersonalPageSubtype, type PersonalPageFamily } from '../subtypes';
import { resolveCapabilities } from './resolve-capabilities';
import type { PersonalPageCapabilities } from './types';

type PersonalPageSubtypeInput = {
  pageSubtype?: string;
  registrationType?: 'form' | 'tickets';
};

export function resolvePageCapabilities(page: PersonalPageSubtypeInput): PersonalPageCapabilities {
  const pageSubtype = isPersonalPageSubtype(page.pageSubtype) ? page.pageSubtype : undefined;
  return resolveCapabilities(resolveEffectiveSubtype({ pageSubtype, registrationType: page.registrationType }));
}

export function usesItemInventory(capabilities: Pick<PersonalPageCapabilities, 'itemOptions'>): boolean {
  return capabilities.itemOptions.inventory;
}

export function hasPageRegistrationLimit(capabilities: Pick<PersonalPageCapabilities, 'itemOptions'>): boolean {
  return usesItemInventory(capabilities);
}

export interface PublicActionLabels {
  countdownSubject: string;
  actionText: string;
  hideActionBox: boolean;
}

export function getPublicActionLabels(
  capabilities: Pick<PersonalPageCapabilities, 'itemOptions' | 'dataDestination'>,
  pageFamily: PersonalPageFamily,
  options?: { isServiceRegistration?: boolean; isSmallScreen?: boolean }
): PublicActionLabels {
  const { isServiceRegistration = false, isSmallScreen = false } = options ?? {};

  if (pageFamily === 'campaign') {
    return {
      countdownSubject: 'ההתרמה',
      actionText: 'תרום כעת',
      hideActionBox: false
    };
  }

  if (pageFamily === 'information') {
    if (isServiceRegistration) {
      return {
        countdownSubject: 'ההרשמה',
        actionText: 'להרשמה',
        hideActionBox: false
      };
    }
    return {
      countdownSubject: 'ההרשמה',
      actionText: 'להרשמה',
      hideActionBox: true
    };
  }

  const isFreeRegistration = !capabilities.itemOptions.payments || isServiceRegistration;
  return {
    countdownSubject: isFreeRegistration ? 'ההרשמה' : 'הרכישה המוקדמת',
    actionText: isFreeRegistration ? 'להרשמה' : 'להזמנת כרטיסים',
    hideActionBox: !capabilities.itemOptions.payments && !isSmallScreen
  };
}
